module.exports = __webpack_public_path__ + "img/trinity_construction.52bdb474.png";